__turbopack_context__.v({
  "icon": "TabButton-module__KyLOiG__icon",
  "tabButton": "TabButton-module__KyLOiG__tabButton",
});
